import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export const CAMPAIGN_LANDING_SEARCH_PARAM = 'q'

export function isCampaignLandingPath(pathname: string): boolean {
  return pathname === '/campaigns' || pathname === '/campaigns/'
}

export function useCampaignLandingSearch() {
  const [searchParams, setSearchParams] = useSearchParams()
  const search = searchParams.get(CAMPAIGN_LANDING_SEARCH_PARAM) ?? ''

  const setSearch = useCallback(
    (value: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev)
          const trimmed = value.trim()
          if (trimmed) {
            next.set(CAMPAIGN_LANDING_SEARCH_PARAM, value)
          } else {
            next.delete(CAMPAIGN_LANDING_SEARCH_PARAM)
          }
          return next
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )

  return { search, setSearch }
}
